import { ReactNode } from 'react';
import { Spinner } from '@servicetitan/design-system';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';
import { useVirtualAgentFeatureGate } from '@api/hooks/useVirtualAgentFeatureGate';
import RedirectForbidden from '@app/permissions/RedirectForbidden';
import { FeatureErrorBoundary } from '@components/ErrorBoundary';

interface VoiceAgentDashboardRouteGuardProps {
  children: ReactNode;
}

/**
 * Route guard for the Voice Agent Dashboard.
 * Shows a spinner while feature flags/gates load, redirects to forbidden
 * if the feature is not enabled, or renders children when authorized.
 */
const VoiceAgentDashboardRouteGuard = ({
  children,
}: VoiceAgentDashboardRouteGuardProps) => {
  const {
    [FeatureFlagKeys.featureVoiceAgentReporting]: featureVoiceAgentReporting,
  } = useFeatureFlags();
  const virtualAgentFeatures = useVirtualAgentFeatureGate();

  if (
    featureVoiceAgentReporting === undefined ||
    virtualAgentFeatures.loading
  ) {
    return <Spinner />;
  }

  if (!virtualAgentFeatures.configuration || !featureVoiceAgentReporting) {
    return <RedirectForbidden />;
  }

  return (
    <FeatureErrorBoundary featureName='Voice Agent Dashboard'>
      {children}
    </FeatureErrorBoundary>
  );
};

export default VoiceAgentDashboardRouteGuard;
